import authentication from "@irati/auth"
import {PRODUCTION, STAGING, DEVELOPMENT, LOCAL} from "@irati/utils/constants/environment"

const getMixPanelConfig = (env: string): string | null => {
  if (authentication.isUserGhost()) {
    switch (env) {
      case PRODUCTION:
        return "9902236c668f7eab009532b4b46053cc"
      default:
        return "ddc568e746c593738bc0e284c5614ec8"
    }
  }

  switch (env) {
    case PRODUCTION:
      return "db23a499d137c41fe1659f21e2b6cadf"
    case STAGING:
      return "f0fba8b7964575c06ac542ae54e98ed7"
    case LOCAL:
    case DEVELOPMENT:
      return "6b4f69bfbe4249979741478bdd64b494"
    default:
      return null
  }
}

interface TrackerConfig {
  mixpanel: string | null
}

export const getTrackingConfig = (env: string): TrackerConfig => ({
  mixpanel: getMixPanelConfig(env)
})
